export default "__VITE_ASSET__eabc0766__"